/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3AvgIcpXdrConversionRatesFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3AvgIcpXdrConversionRatesFormat = ClosedEnum<
  typeof GetApiV3AvgIcpXdrConversionRatesFormat
>;

export type GetApiV3AvgIcpXdrConversionRatesRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3AvgIcpXdrConversionRatesFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3AvgIcpXdrConversionRatesFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3AvgIcpXdrConversionRatesFormat> = z.nativeEnum(
    GetApiV3AvgIcpXdrConversionRatesFormat,
  );

/** @internal */
export const GetApiV3AvgIcpXdrConversionRatesFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3AvgIcpXdrConversionRatesFormat> =
    GetApiV3AvgIcpXdrConversionRatesFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3AvgIcpXdrConversionRatesFormat$ {
  /** @deprecated use `GetApiV3AvgIcpXdrConversionRatesFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3AvgIcpXdrConversionRatesFormat$inboundSchema;
  /** @deprecated use `GetApiV3AvgIcpXdrConversionRatesFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3AvgIcpXdrConversionRatesFormat$outboundSchema;
}

/** @internal */
export const GetApiV3AvgIcpXdrConversionRatesRequest$inboundSchema: z.ZodType<
  GetApiV3AvgIcpXdrConversionRatesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number().int()).default(null),
  format: GetApiV3AvgIcpXdrConversionRatesFormat$inboundSchema.default("json"),
  start: z.nullable(z.number().int()).default(null),
  step: z.number().default(86400),
});

/** @internal */
export type GetApiV3AvgIcpXdrConversionRatesRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3AvgIcpXdrConversionRatesRequest$outboundSchema: z.ZodType<
  GetApiV3AvgIcpXdrConversionRatesRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3AvgIcpXdrConversionRatesRequest
> = z.object({
  end: z.nullable(z.number().int()).default(null),
  format: GetApiV3AvgIcpXdrConversionRatesFormat$outboundSchema.default("json"),
  start: z.nullable(z.number().int()).default(null),
  step: z.number().default(86400),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3AvgIcpXdrConversionRatesRequest$ {
  /** @deprecated use `GetApiV3AvgIcpXdrConversionRatesRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3AvgIcpXdrConversionRatesRequest$inboundSchema;
  /** @deprecated use `GetApiV3AvgIcpXdrConversionRatesRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3AvgIcpXdrConversionRatesRequest$outboundSchema;
  /** @deprecated use `GetApiV3AvgIcpXdrConversionRatesRequest$Outbound` instead. */
  export type Outbound = GetApiV3AvgIcpXdrConversionRatesRequest$Outbound;
}

export function getApiV3AvgIcpXdrConversionRatesRequestToJSON(
  getApiV3AvgIcpXdrConversionRatesRequest:
    GetApiV3AvgIcpXdrConversionRatesRequest,
): string {
  return JSON.stringify(
    GetApiV3AvgIcpXdrConversionRatesRequest$outboundSchema.parse(
      getApiV3AvgIcpXdrConversionRatesRequest,
    ),
  );
}

export function getApiV3AvgIcpXdrConversionRatesRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3AvgIcpXdrConversionRatesRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3AvgIcpXdrConversionRatesRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3AvgIcpXdrConversionRatesRequest' from JSON`,
  );
}
